// src/components/RoleProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * RoleProtectedRoute - Protects routes based on user role
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - The component to render if authorized
 * @param {string[]} props.allowedRoles - Array of roles that can access this route
 * @param {string} props.redirectTo - Where to redirect if unauthorized (default: /home)
 */
export default function RoleProtectedRoute({
  children,
  allowedRoles = [],
  redirectTo = '/home'
}) {
  const { session, sessionLoading } = useAuth();

  // Show loading state while session is being fetched
  if (sessionLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#18365E] mx-auto mb-4"></div>
          <p className="text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Check if user has required role
  const userRole = session?.role;
  const hasAccess = userRole && allowedRoles.includes(userRole);

  if (!hasAccess) {
    console.warn(`Access denied. User role: ${userRole}, Required roles: ${allowedRoles.join(', ')}`);
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
